import { CalendarManagementActionsEnum, CalendarManagementViewEnum } from './types';
import { CustomMessage, UserRoleIDEnum } from '@alluradirect/react';

import { EventTypeEnum } from '@alluradirect/react';

export const initialUIDashboardState = {
  eventDrawer: {
    type: EventTypeEnum.Season as EventTypeEnum | null,
    isOpen: false,
  },
  messageGuestDialog: {
    isOpen: false,
    data: {
      bookingId: 0,
      contactTypeId: UserRoleIDEnum.guest,
      contactId: 0,
    },
  },
  calendarManagementDialog: {
    bookingId: 0,
    action: undefined as CalendarManagementActionsEnum | undefined,
    activeStep: 0,
    currentView: CalendarManagementViewEnum.dateSelect,
    isOpen: false,
    rates: {
      nights: 0,
      rate: 0,
    },
    paymentInformation: {
      BOOKING_NET_BASE_RATE: 0,
      LENGTH_OF_STAY_DISCOUNT: 0,
      ACCOMMODATION_SUBTOTAL: 0,
      ALLURA_OFFER_DISCOUNT: 0,
      OWNER_OFFER_DISCOUNT: 0,
    },
  },
  notificationDrawer: {
    isOpen: false,
  },
  inquiryOwnerResponses: {
    isOpen: false,
  },
  navDrawer: {
    isOpen: false,
  },
  ratesWizardDialog: {
    isOpen: false,
  },
  availabilityWizard: {
    isOpen: false,
  },
  customMessageDialog: {
    bookingId: 0,
    isOpen: false,
    customMessage: {
      MESSAGE: '',
      ENTRY_CODE: '',
    } as CustomMessage,
    bookingReference: '',
  },
  /** Used to force a re-render of the rateSchedulePage */
  rateScheduleKey: 0,
};
